"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _Diamond = require("./Diamond.styles");

var _svgElements = require("../../components/svg-elements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Diamond = function Diamond(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var diamondConfig = config || _hotspot.diamond;
  var backgroundColor = diamondConfig.backgroundColor,
      borderColor = diamondConfig.borderColor,
      hoverStyle = diamondConfig.hoverStyle,
      iconColor = diamondConfig.iconColor;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_Diamond.ClickableAreaStyled, {
    hoverStyle: hoverStyle,
    onClick: onClick,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_Diamond.DiamondStyled, {
    config: diamondConfig,
    iconPosition: iconPosition
  }, _react.default.createElement(_Diamond.DiamondCenter, {
    backgroundColor: backgroundColor
  }, _react.default.createElement(_Diamond.Plus, {
    viewBox: "0 0 74 74",
    preserveAspectRatio: "xMinYMin"
  }, _react.default.createElement(_svgElements.Path, {
    strokeWidth: "0.1",
    stroke: iconColor,
    fill: iconColor,
    strokeOpacity: "1",
    d: "M 74,33 74,41 41,41 41,74 33,74 33,41 0,41 0,33 33,33 33,0 41,0 41,33 z"
  }))), _react.default.createElement(_Diamond.DiamondOutline, {
    borderColor: borderColor
  })));
};

var _default = Diamond;
exports.default = _default;